import { NavLink } from 'react-router-dom'
import styled from 'styled-components'
import { ListItemSkeleton } from '@sketch/components'
import { ReactComponent as ChatBubblesIcon } from '@sketch/icons/chat-bubbles-17'

export const UnreadCommentIcon = styled(ChatBubblesIcon)`
  width: 17px;
  height: 17px;
  margin-left: auto;
  justify-self: end;
  color: ${({ theme }) => theme.colors.sketch.A};
`

export const SidebarItem = styled(NavLink)`
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0px 8px;
  padding: 8px 12px;
  font-size: ${({ theme }) => theme.fontSizes.D};
  line-height: ${({ theme }) => theme.lineHeights.default};
  color: ${({ theme }) => theme.colors.foreground.secondary.D};
  border-radius: 5px;

  &:hover {
    background: ${({ theme }) => theme.colors.background.tertiary.C};
    color: ${({ theme }) => theme.colors.foreground.secondary.A};
  }

  &.active {
    color: ${({ theme }) => theme.colors.sketch.A};
    background: ${({ theme }) => theme.colors.sketch.F};
  }
`

export const Skeleton = styled(ListItemSkeleton)`
  pointer-events: none;
  > span {
    height: 19px;
    margin: 8px 20px;
  }
`
